import auth from './authReducer';
import user from './userReducer';
import order from './orderReducer';
import notifications from './notificationReducer';
import modal from './modalReducer';
import nav from './navReducer';
import popups from './popupReducer';
import settings from './settingsReducer';
import experiments from './experimentReducer';
import utility from './utilityReducer';

export default {
  auth,
  user,
  order,
  modal,
  notifications,
  popups,
  nav,
  settings,
  experiments,
  utility,
};



// WEBPACK FOOTER //
// ./src/reducers/index.js